module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gc786"))).then(() => parcelRequire('d0iPb'));